import React, { useContext, useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import { toast } from "react-toastify";
import { separate } from "../../tools/helper";
import { favoriteCheck, setFavorite } from "../../axios";
import { Link, useLocation, useParams } from "react-router-dom";
import { CartContext } from "../shared/context/cart-context";
import ProductOne from "./productOne";
import SwiperComp from "../SwiperComp";
import { SwiperSlide } from "swiper/react";

const ProductDetails = ({ products, recived }) => {
  const location = useLocation();
  const { id } = useParams();
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const addToFavorite = (e, id) => {
    e.preventDefault();

    if (localStorage.getItem("login")) {
      favoriteCheck(id, localStorage.getItem("phonenumber")).then(
        ({ data }) => {}
      );
      setFavorite(id, localStorage.getItem("phonenumber")).then(({ data }) => {
        toast.success("به لیست علاقه مندی ها اضافه شد");
      });
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const [cartItems, setCartItems] = useContext(CartContext);

  const addToSabadKharidHandler = (e, value) => {
    e.preventDefault();
    if (localStorage.getItem("login")) {
      try {
        let array = [...cartItems];
        array.push(value);
        setCartItems(array);
        toast.success("به سبد خرید اضافه شد");
      } catch (error) {
        console.log("ProductDetail:::::::::", error);
      }
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const [someProduct, setSomeProduct] = useState([]);
  useEffect(() => {
    // let newData = products.filter((item) => item.id != id);
    // setSomeProduct(newData); // error two show product

    const uniqueProducts = Array.from(
      new Set(products.map(JSON.stringify)),
      JSON.parse
    );
    setSomeProduct(uniqueProducts);
  }, [products]);

  return (
    <div className="product-area ptb-100">
      <div>
        <div className="row">
          <SwiperComp>
            {someProduct?.map((item, index) =>
              item.isSite === true && item.categoryTitle !== "فلش کارت" && item.id !== recived?.id   ? (
                <div key={index} className="col-lg-3 col-sm-6">
                  <SwiperSlide key={index} className="d-flex align-items-center justify-content-center">
                    <ProductOne
                      item={item}
                      recived={recived}
                      hover={
                        item.type === "audio" || item.type === "video"
                          ? false
                          : true
                      }
                    />
                  </SwiperSlide>
                </div>
              ) : (
                ""
              )
            )}
          </SwiperComp>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
